import { API_URL, getAuthHeaders } from './config';

export const plansService = {
    getAll: async () => {
        const res = await fetch(`${API_URL}/public/plans`);
        return res.ok ? res.json() : [];
    },
    create: async (data: any) => {
        const res = await fetch(`${API_URL}/admin/plans`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to create plan");
        return res.json();
    },
    update: async (id: number, data: any) => {
        const res = await fetch(`${API_URL}/admin/plans/${id}`, {
            method: 'PUT',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to update plan");
        return res.json();
    },
    delete: async (id: number) => {
        await fetch(`${API_URL}/admin/plans/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
    }
};
